/* eslint-disable no-console*/
import React from 'react';
var useEffect = React.useEffect, useRef = React.useRef;
export function useLogger(_a) {
    var state = _a[0], dispatch = _a[1];
    var actionRef = useRef();
    var newDispatchRef = useRef(function (action) {
        actionRef.current = action;
        dispatch(action);
    });
    useEffect(function () {
        var action = actionRef.current;
        if (action) {
            console.group('Dispatch');
            console.log('Action:', action);
            console.log('State:', state);
            console.groupEnd();
        }
    }, [state]);
    return [state, newDispatchRef.current];
}
